import { createBrowserRouter, Navigate } from "react-router-dom";
import { UnloggedLayout } from "./layouts/unloggedLayout.jsx";
import { LoginPage } from "./pages/auth/loginPage.jsx";
import { SignupPage } from "./pages/auth/signupPage.jsx";
import { LoggedLayout } from "./layouts/loggedLayout.jsx";
import { ErrorPage } from "./pages/errorPage.jsx";
import { ContactPage } from "./pages/app/contact/contactPage.jsx";
import { TransactionPage } from "./pages/app/transaction/transactionPage.jsx";
import { DocumentPage } from "./pages/app/document/documentPage.jsx";
import { SettingsCompanyPage } from "./pages/app/settings/account/company/settingsCompanyPage.jsx";
import { SettingsBillingPage } from "./pages/app/settings/general/billing/settingsBillingPage.jsx";
import { TeamPage } from "./pages/app/settings/account/team/teamPage.jsx";
import { HelpPage } from "./pages/app/settings/general/help/helpPage.jsx";
import { LogoutPage } from "./pages/auth/logoutPage.jsx";
import React from "react";
import { SettingsIntegrationsPage } from "./pages/app/settings/general/integrations/settingsIntegrationsPage.jsx";
import { ResetPage } from "./pages/auth/resetPage.jsx";
import { ConfirmPage } from "./pages/auth/confirmPage.jsx";
import { ContactEditPage } from "./pages/app/contact/contactEditPage.jsx";
import { TransactionEditPage } from "./pages/app/transaction/transactionEditPage.jsx";
import { DocumentEditPage } from "./pages/app/document/documentEditPage.jsx";
import { SettingsHomePage } from "./pages/app/settings/settingsHomePage.jsx";
import { SettingsAccountingPage } from "./pages/app/settings/applications/accounting/settingsAccountingPage.jsx";
import { AppLayout } from "./pages/app/appLayout";

export const router = createBrowserRouter([
  {
    path: "/auth",
    element: <UnloggedLayout />,
    children: [
      { path: "login", element: <LoginPage /> },
      { path: "reset", element: <ResetPage /> },
      { path: "confirm", element: <ConfirmPage /> },
      { path: "signup", element: <SignupPage /> },
    ],
  },
  {
    path: "/",
    element: <LoggedLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <AppLayout />,
        children: [
          { path: "", element: <Navigate to={"/transactions"} /> },
          { path: "contacts", element: <ContactPage /> },
          { path: "contacts/:id", element: <ContactEditPage /> },
          { path: "transactions", element: <TransactionPage /> },
          { path: "transactions/:id", element: <TransactionEditPage /> },
          {
            path: "documents",
            element: <DocumentPage />,
          },
          {
            path: "documents/:id",
            element: <DocumentEditPage />,
          },
          {
            path: "settings",
            children: [
              { path: "", element: <SettingsHomePage /> },
              { path: "accounting", element: <SettingsAccountingPage /> },
              { path: "company", element: <SettingsCompanyPage /> },
              { path: "integrations", element: <SettingsIntegrationsPage /> },
              { path: "billing", element: <SettingsBillingPage /> },
              { path: "team", element: <TeamPage /> },
              { path: "help", element: <HelpPage /> },
            ],
          },
        ],
      },

      { path: "logout", element: <LogoutPage /> },
    ],
  },
]);
